module.exports = __webpack_public_path__ + "img/01.6305e401.png";